import request from "@/utils/request";
import axios from "axios";
import store from "@/store";

export function fetchList(params) {
  return request({
    url: "/web/article/list",
    method: "get",
    params: params,
  });
}
export function getArticleInfo(id) {
  return request({
    url: "/web/article/info",
    method: "get",
    params: {
      id: id,
    },
  });
}
export function searchArticle(keywords) {
  return request({
    url: "/web/article/searchArticle",
    method: "get",
    params: {
      keywords: keywords,
    },
  });
}
//分类标签id获取文章
export function queryIdToArticles(params) {
  return request({
    url: "/web/article/condition",
    method: "get",
    params: params,
  });
}
export function like(id) {
  return request({
    url: "/web/article/articleLike",
    method: "get",
    params: { articleId: id },
  });
}
export function checkSecret(params) {
  return request({
    url: "/web/article/checkSecret",
    method: "get",
    params: params,
  });
}
//友链页面请求接口
export function addLink(data) {
  return request({
    url: "/web/friend/add",
    method: "POST",
    data,
  });
}
export function fetchFriend() {
  return request({
    url: "/web/friend/list",
    method: "post",
    params: {},
  });
}
export function getWebSiteInfo() {
  return request({
    url: "/web/home/webSiteInfo",
    method: "get",
    params: {},
  });
}
export function getFrontVersion() {
  return axios.get(location.protocol + "//" + location.host + "/version.json");
}

//留言接口
export function addMessage(data) {
  return request({
    url: "/web/message/add",
    method: "post",
    data,
  });
}

export function listMessage(params) {
  return request({
    url: "/web/message/webMessage",
    method: "get",
    params: params,
  });
}
//添加评论
export function addComment(data) {
  return request({
    url: "/web/comment/addComment",
    method: "post",
    data,
  });
}
//评论列表
export function fetchComments(params) {
  return request({
    url: "/web/comment/comments",
    method: "get",
    params: params,
  });
}
//查询回复评论
export function repliesByComId(params) {
  return request({
    url: "/web/comment/repliesByComId",
    method: "get",
    params: params,
  });
}

//标签接口
export function getTags() {
  return request({
    url: "/web/tags/list",
    method: "get",
    params: {},
  });
}
//分类接口
export function getCategory() {
  return request({
    url: "/web/tags/categoryList",
    method: "get",
    params: {},
  });
}
//归档接口
export function getArchive(params) {
  return request({
    url: "/web/article/archive",
    method: "get",
    params: params,
  });
}
//chatgpt列表接口
export function getChatgptMessage(params) {
  return request({
    url: "/ai/chatgpt/list",
    method: "get",
    params: params,
  });
}
//chatgpt统计信息接口
export function getChatgptStat(params) {
  return request({
    url: "/ai/chatgpt/statistics",
    method: "get",
    params: params,
  });
}

//chatgpt提问接口
export function askChatgpt(data) {
  return request({
    url: "/ai/chatgpt/ask",
    method: "post",
    data,
  });
}

//chatgpt销毁信息接口
export function ruinChatgptMessage() {
  return request({
    url: "/ai/chatgpt/ruin",
    method: "delete",
  });
}

//chatgpt分享信息
export function shareToSquare(params) {
  return request({
    url: "/ai/chatgpt/share-to-square",
    method: "get",
    params: params,
  });
}
//chatgpt收藏
export function addToFavorites(params) {
  return request({
    url: "/ai/chatgpt/add-to-favorites",
    method: "get",
    params: params,
  });
}
//aiart收藏
export function addToFavoritesAiArt(params) {
  return request({
    url: "/ai/art/message/add-to-favorites",
    method: "get",
    params: params,
  });
}

//删除单条信息
export function deleteMsg(params) {
  return request({
    url: "/ai/chatgpt/delete",
    method: "delete",
    params: params,
  });
}

//隐藏单条信息
export function hideMsg(params) {
  return request({
    url: "/ai/chatgpt/hide",
    method: "put",
    params: params,
  });
}

//显示单条信息
export function showMsg(params) {
  return request({
    url: "/ai/chatgpt/show",
    method: "put",
    params: params,
  });
}

//chatgpt square列表接口
export function getChatgptSquareInfo(params) {
  return request({
    url: "/ai/chatgpt/square/query",
    method: "get",
    params: params,
  });
}

//chatgpt模型列表接口
export function getChatgptModelList() {
  return request({
    url: "ai/chatgpt/model/list",
    method: "get",
  });
}

//chatgpt square互动
export function reactionChatgptSquareInfo(params) {
  return request({
    url: "/ai/chatgpt/square/reaction",
    method: "get",
    params: params,
  });
}

//audio square查看
export function viewChatgptSquareInfo(params) {
  return request({
    url: "/ai/chatgpt/square/view",
    method: "get",
    params: params,
  });
}

//audio square列表接口
export function getAiAudioSquareInfo(params) {
  return request({
    url: "/ai/audio/square/query",
    method: "get",
    params: params,
  });
}
//audio分享信息
export function shareAiAudioToSquare(params) {
  return request({
    url: "/ai/audio/message/share-to-square",
    method: "get",
    params: params,
  });
}

//audio square互动
export function reactionAiAudioSquareInfo(params) {
  return request({
    url: "/ai/audio/square/reaction",
    method: "get",
    params: params,
  });
}

//audio square查看
export function viewAiAudioSquareInfo(params) {
  return request({
    url: "/ai/audio/square/view",
    method: "get",
    params: params,
  });
}

//chatgpt 获取配置角色信息接口
export function getChatgptRoleConfig() {
  return request({
    url: "/ai/chatgpt/role-config",
    method: "get",
  });
}

//ai art列表接口
export function getAiArtMessage(params) {
  return request({
    url: "/ai/art/message/list",
    method: "get",
    params: params,
  });
}
//ai art统计信息接口
export function getAiArtStat(params) {
  return request({
    url: "/ai/art/message/statistics",
    method: "get",
    params: params,
  });
}

//ai art提问接口
export function askAiArt(data) {
  return request({
    url: "/ai/art/message/ask",
    method: "post",
    data,
  });
}

//ai art销毁信息接口
export function ruinAiArtMessage() {
  return request({
    url: "/ai/art/message/ruin",
    method: "delete",
  });
}

//ai art删除单条信息接口
export function deleteAiArtMessage(params) {
  return request({
    url: "/ai/art/message/delete",
    method: "delete",
    params: params,
  });
}

//ai art分享接口
export function shareArt(params) {
  return request({
    url: "/ai/art/message/share",
    method: "get",
    params: params,
  });
}

//////

//ai Audio列表接口
export function getAiAudioMessage(params) {
  return request({
    url: "/ai/audio/message/list",
    method: "get",
    params: params,
  });
}
//ai Audio统计信息接口
export function getAiAudioStat(params) {
  return request({
    url: "/ai/audio/message/statistics",
    method: "get",
    params: params,
  });
}

//ai Audio提问接口
export function askAiAudio(data) {
  return request({
    url: "/ai/audio/message/ask",
    method: "post",
    data,
  });
}

//ai Audio销毁信息接口
export function ruinAiAudioMessage() {
  return request({
    url: "/ai/audio/message/ruin",
    method: "delete",
  });
}

//ai Audio删除单条信息接口
export function deleteAiAudioMessage(params) {
  return request({
    url: "/ai/audio/message/delete",
    method: "delete",
    params: params,
  });
}
//ai art获取配置信息接口
export function getAiArtConfig(params) {
  return request({
    url: "/ai/art/message/config",
    method: "get",
    params: params,
  });
}

//ai Audio获取配置信息接口
export function getAiAudioConfig(params) {
  return request({
    url: "/ai/audio/message/config",
    method: "get",
    params: params,
  });
}

//充值
export function precreateAlipay(data) {
  return request({
    url: "/alipay/trade-precreate",
    method: "post",
    data,
  });
}
//充值查询
export function checkOkAlipay(params) {
  return request({
    url: "/alipay/trade-check-ok",
    method: "get",
    params: params,
  });
}
//qq登录
export function qqLogin(data) {
  return request({
    url: "/user/login",
    method: "post",
    data,
  });
}
//qq退出
export function logout() {
  return request({
    url: "/logout",
    method: "get",
  });
}
//gitee登录
export function gitEELogin(params) {
  return request({
    url: "/user/gitEELogin",
    method: "get",
    params: params,
  });
}
//微博登录
export function weiboLogin(code) {
  return request({
    url: "/user/weiboLogin",
    method: "get",
    params: {
      code: code,
    },
  });
}
//添加访客信息
export function report() {
  return request({
    url: "/web/home/report",
    method: "get",
    params: {},
  });
}
//相册接口
export function getAlbum() {
  return request({
    url: "/web/album/list",
    method: "get",
    params: {},
  });
}
export function getPhotos(params) {
  return request({
    url: "/web/album/listPhotos",
    method: "get",
    params: params,
  });
}

// 检索Arts
export function queryArts(params) {
  return request({
    url: "/ai/art/query",
    method: "get",
    params: params,
  });
}
// 喜欢Arts
export function likeArt(params) {
  return request({
    url: "/ai/art/like",
    method: "get",
    params: params,
  });
}
// 查看Art
export function viewArt(params) {
  return request({
    url: "/ai/art/view",
    method: "get",
    params: params,
  });
}
// 获取作品总数量
export function getArtTotalNum(params) {
  return request({
    url: "/ai/art/get-total",
    method: "get",
    params: params,
  });
}
export function selectAiArtSref(params) {
  return request({
    url: "/ai/art/query-sref",
    method: "get",
    params: params,
  });
}
export function addFeedback(data) {
  return request({
    url: "/web/feedback/add",
    method: "post",
    data,
  });
}
export function sendEmailCode(email) {
  return request({
    url: "/user/sendEmailCode",
    method: "get",
    params: {
      email: email,
    },
  });
}
export function bindEmail(data) {
  return request({
    url: "/user/bindEmail",
    method: "post",
    data,
  });
}
export function emailRegister(data) {
  return request({
    url: "/user/emailRegister",
    method: "post",
    data,
  });
}
export function emailLogin(data) {
  return request({
    url: "/user/emailLogin",
    method: "post",
    data,
  });
}
export function updatePassword(data) {
  return request({
    url: "/user/updatePassword",
    method: "post",
    data,
  });
}
export function upload(data) {
  return request({
    url: "/file/upload",
    method: "POST",
    headers: { "Content-Type": "multipart/articles-data" },
    data,
  });
}
export function uploadAvatar(data) {
  return request({
    url: "/file/upload-avatar",
    method: "POST",
    headers: { "Content-Type": "multipart/articles-data" },
    data,
  });
}
export function updateUser(data) {
  return request({
    url: "/user/updateUser",
    method: "post",
    data,
  });
}

export function getUserScore() {
  return request({
    url: "/user/get-user-score",
    method: "get",
  });
}

export function getUserSkillConfig() {
  return request({
    url: "/user/get-user-skill-config",
    method: "get",
  });
}

export function getUserSkill() {
  return request({
    url: "/user/get-user-skill",
    method: "get",
  });
}
export function assignSkillPoints(data) {
  return request({
    url: "/user/assign-skill-points",
    method: "POST",
    data,
  });
}

export function queryAds(params) {
  return request({
    url: "/ads/query",
    method: "get",
    params: params,
  });
}

export function clickAds(id) {
  return request({
    url: "/ads/click",
    method: "get",
    params: {
      id: id,
    },
  });
}

export function emulatorStatistics(params) {
  return request({
    url: "/game/emulator/statistics",
    method: "get",
    params: params,
  });
}

export function emulatorGetGameInfo(params) {
  return request({
    url: "/game/emulator/warehouse/get-game-info",
    method: "get",
    params: params,
  });
}

export function emulatorQueryGameInfoList(params) {
  return request({
    url: "/game/emulator/warehouse/query-game-info-list",
    method: "get",
    params: params,
  });
}

export function emulatorGetGameCatalogCore(params) {
  return request({
    url: "/game/emulator/warehouse/get-game-catalog-core",
    method: "get",
    params: params,
  });
}

export function emulatorGetGameCatalogCategory(params) {
  return request({
    url: "/game/emulator/warehouse/get-game-catalog-category",
    method: "get",
    params: params,
  });
}

export function emulatorQueryMygames(params) {
  return request({
    url: "/game/emulator/mygames/query-mygames",
    method: "get",
    params: params,
  });
}

export function emulatorStartGame(params) {
  return request({
    url: "/game/emulator/mygames/start-game",
    method: "get",
    params: params,
  });
}

export function emulatorAddNewGame(params) {
  return request({
    url: "/game/emulator/mygames/add-new-game",
    method: "post",
    params: params,
  });
}

export function emulatorSaveAdd(data) {
  return request({
    url: "/game/emulator/save/add",
    method: "post",
    data,
  });
}
export function emulatorSaveGet(params) {
  return request({
    url: "/game/emulator/save/get",
    method: "get",
    params: params,
  });
}
export function emulatorSaveList(params) {
  return request({
    url: "/game/emulator/save/list",
    method: "get",
    params: params,
  });
}

//User
export function userNotifyGet() {
  return request({
    url: "/user/get-user-notify",
    method: "get",
  });
}
export function userConfigGet() {
  return request({
    url: "/user/get-user-config",
    method: "get",
  });
}
export function userConfigUpdate(data) {
  return request({
    url: "/user/update-user-config",
    method: "post",
    data,
  });
}

//AI问答 Role
export function getCustomRole() {
  return request({
    url: "/ai/chatgpt/custom-role",
    method: "get",
  });
}
export function addCustomRole(data) {
  return request({
    url: "/ai/chatgpt/add-custom-role",
    method: "post",
    data,
  });
}
export function deleteCustomRole(params) {
  return request({
    url: "/ai/chatgpt/delete-custom-role",
    method: "post",
    params: params,
  });
}

// LOG
export function userConsumeLogList(params) {
  return request({
    url: "/user/consume/log/list",
    method: "get",
    params: params,
  });
}

// Toolbox
export function toolboxList() {
  return request({
    url: "/toolbox/list",
    method: "get",
  });
}
export function toolboxTagsConfig() {
  return request({
    url: "/toolbox/tags-config",
    method: "get",
  });
}
export function toolboxView(params) {
  return request({
    url: "/toolbox/view",
    method: "post",
    params: params,
  });
}
export function toolboxRate(params) {
  return request({
    url: "/toolbox/rate",
    method: "post",
    params: params,
  });
}

//////

//bgSound列表接口
export function queryBgSounds(params) {
  return request({
    url: "/bgsound/query",
    method: "get",
    params: params,
  });
}
export function addBgSoundSchema(data) {
  return request({
    url: "/bgsound/schema/add",
    method: "post",
    data,
  });
}
export function shareBgSoundSchema(params) {
  return request({
    url: "/bgsound/schema/share",
    method: "post",
    params: params,
  });
}
export function refShareBgSoundSchema(params) {
  return request({
    url: "/bgsound/schema/ref",
    method: "get",
    params: params,
  });
}
export function queryMyBgSoundSchemas(params) {
  return request({
    url: "/bgsound/schema/query-self",
    method: "get",
    params: params,
  });
}
export function queryShareBgSoundSchemasByRef(params) {
  return request({
    url: "/bgsound/schema/query-share-ref",
    method: "get",
    params: params,
  });
}
export function queryShareBgSoundSchemasByDate(params) {
  return request({
    url: "/bgsound/schema/query-share-date",
    method: "get",
    params: params,
  });
}
export function deleteBgSoundSchema(params) {
  return request({
    url: "/bgsound/schema/delete",
    method: "delete",
    params: params,
  });
}

// 文档上传接口
export function uploadDocument(data) {
  return request({
    url: "/document/upload",
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data,
  });
}

// 获取文档token预估
export function estimateDocumentTokens(params) {
  return request({
    url: "/ai/chatgpt/document/estimate-tokens",
    method: "get",
    params,
  });
}

// 创建带基础配置的fetch实例
const baseFetch = (url, options = {}) => {
  const baseURL = process.env.VUE_APP_BASE_API;
  return fetch(`${baseURL}${url}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `${getToken()}`,
      ...options.headers,
    },
  });
};

// 添加token获取函数
const getToken = () => {
  try {
    // 从vuex store获取
    const storeState = JSON.parse(localStorage.getItem("store"));
    return storeState?.state?.token || localStorage.getItem("token") || "";
  } catch (e) {
    return localStorage.getItem("token") || "";
  }
};

// 流式请求接口
export function askChatgptStream(data) {
  return baseFetch("/ai/chatgpt/ask-stream", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

// 添加搜索聊天记录的接口
export function searchChatgptMessages(params) {
  return request({
    url: "/ai/chatgpt/search",
    method: "get",
    params: params,
  });
}

// 添加获取消息位置的接口
export function getChatgptMessagePosition(messageId, pageSize) {
  return request({
    url: `/ai/chatgpt/message/position/${messageId}`,
    method: "get",
    params: { pageSize },
  });
}
